import Cabecalho from './components/Cabecalho';
import Inicio from './components/Inicio';
import Sobre from './components/Sobre';
import Especialidades from './components/Especialidades';
import ComoFunciona from './components/ComoFunciona';
import Duvidas from './components/Duvidas';
import Contato from './components/Contato';
import Rodape from './components/Rodape';
import BotaoWhatsApp from './components/BotaoWhatsApp';

function App() {
  return (
    <>
      <a className="pular-para-conteudo" href="#conteudo">
        Pular para o conteúdo
      </a>
      <Cabecalho />
      <main id="conteudo">
        <Inicio />
        <Sobre />
        <Especialidades />
        <ComoFunciona />
        <Duvidas />
        <Contato />
      </main>
      <Rodape />
      <BotaoWhatsApp />
    </>
  );
}

export default App;
